import { Component, inject, Input } from '@angular/core';
import { IndicatorStore } from '../../../stores/indicator/indicator.state';
import { CountBoxComponent } from '../../atoms/count-box/count-box.component';

@Component({
  selector: 'app-count-box-indicator',
  standalone: true,
  imports: [CountBoxComponent],
  templateUrl: './count-box-indicator.component.html',
  styleUrl: './count-box-indicator.component.scss',
})
export class CountBoxIndicatorComponent {
  readonly store = inject(IndicatorStore);
  @Input() title = 'Indikatoren';
  @Input() text = '';
  @Input() styleClass = '';
}
